import { createRouter, createWebHistory } from 'vue-router';
import WeavingCostingCalculator from './pages/WeavingCostingCalculator.vue';
import KhataKharchSettings from './pages/KhataKharchSettings.vue';

const routes = [
  { path: '/', component: WeavingCostingCalculator },
  { path: '/khatakharch', component: KhataKharchSettings }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;